import React from 'react'
import { useSelector } from 'react-redux'

export default function LogoComponent() {

  const Flags = useSelector(state => state.accountsData.Flags)

  return (
    <div className='d-flex align-items-center justify-content-center h-100 w-100 p-2'>
      <img height="100%" alt="KontoLogo" style={{width: '100%', objectFit: 'contain'}} src={Flags.KontoLogo}/>
      </div>
  )
}
